export const defaultLegacySiteBaseUrl = "https://www.b50first.com/prod";

export const sidebarMenuUrl = "/heartbeat/GetUserSidebarMenu";
